<template>
    <div class="container-fluid">
        <nav-header :navItems="[
            {
                name: 'Configuration',
                link: {
                    name: 'Job Configuration',
                    params: { sandboxId: `${selectedSandbox}`, jobId: `${$route.params.jobId}` },
                },
            },
            {
                name: 'Meters',
                link: {
                    name: 'Job Meters',
                    params: {
                        sandboxId: `${selectedSandbox}`,
                        jobId: `${$route.params.jobId}`,
                    },
                },
            },
            {
                name: 'Parameters',
                link: {
                    name: 'Job Parameters',
                    params: {
                        sandboxId: `${selectedSandbox}`,
                        jobId: `${$route.params.jobId}`,
                    },
                },
                disable: !showParametersTab,
            },
            {
                name: 'Override',
                link: {
                    name: 'Job Override',
                    params: {
                        sandboxId: `${selectedSandbox}`,
                        jobId: `${$route.params.jobId}`,
                    },
                },
                disable: !showOverrideTab,
            },
            {
                name: 'Run History',
                link: {
                    name: 'Job Run History',
                    params: { sandboxId: `${selectedSandbox}`, jobId: `${$route.params.jobId}` },
                },
            },
            {
                name: `${$route.params.executionId}`,
                link: {
                    name: 'Job Execution Details',
                    params: { sandboxId: `${selectedSandbox}`, jobId: `${$route.params.jobId}`, executionId: ` ` }
                },
                closeTab: true,
                disable: true
            },
            {
                name: 'Promotions',
                link: {
                    name: 'Job Promotions',
                    params: { sandboxId: `${selectedSandbox}`, jobId: `${$route.params.jobId}` }
                },
                disable: !isProdV2Sandbox
            },


        ]" pretitle="aqfer Marketing Data Platform" :breadcrumbTitle=true @nav-close-clicked="closeNav">
            <template v-slot:breadcrumb-title>
                <nav aria-label="breadcrumb" class="header-title">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a @click="closeClick" href="#" class="h1">{{ isPipelineJob ? "Pipelines" : "Jobs" }}</a></li>
                        <li class="breadcrumb-item active h1" aria-current="page">{{ $route.params.jobId }}</li>
                    </ol>
                </nav>
            </template>
            <template v-slot:header-button-content>
                <div class="custom-btn-group">
                    <span v-if="isAccessByUserRole(editDeleteOverrideRoles) && overrideEditMode && !showOverrideEdit">
                        <button @click.prevent="setSaveOverride()" class="btn btn-success" :disabled="isButtonDisabled">
                            <i v-if="isButtonDisabled" class="fa fa-circle-exclamation" title="Please fix lint errors"
                                data-bs-toggle="tooltip" data-bs-placement="left"></i>
                            Save Override</button>
                        <button @click.prevent="onOverrideDeleteClick()" class="btn btn-danger">
                            Delete</button>
                        <button @click.prevent="onOverrideCancelClick()" class="btn btn-secondary">
                            Cancel</button>
                    </span>
                    <span
                        v-else-if="isAccessByUserRole(editDeleteOverrideRoles) && !overrideEditMode && showOverrideEdit">
                        <button type="button" @click.prevent="onOverrideEditClick()" class="btn btn-primary">
                            Edit</button>
                    </span>
                    <button v-if="!hideRunJobBtn && isProdV2Sandbox" @click="runBtnClick" class="btn btn-primary"
                        :disabled="isButtonDisabled">
                        <div v-if="runClicked" class="spinner-border spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div v-else>
                            <slot></slot>
                            <i v-if="isButtonDisabled" class="fa fa-circle-exclamation" title="Please fix lint errors"
                                data-bs-toggle="tooltip" data-bs-placement="right"></i>
                            Run Job
                        </div>
                    </button>
                    <div class="input-group" v-if="checkReRunJobRoles && !hideReRunJobBtn"
                        style="width: auto; margin-right: 12px;">
                        <button @click.prevent="reRunJobClick" :disabled="reRunning" class="btn btn-info"
                            :class="[reRunning ? 'rerunning-btn' : 'rerun-btn']">
                            <div v-if="reRunning" class="spinner-border spinner-border-sm me-1" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            Rerun Job
                            <i class="fa fa-circle-info ms-1"
                                title="Rerun a failed/cancelled job execution. For custom image, use <strong>Rerun with Image</strong> option."
                                data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-html="true"></i>
                        </button>
                        <div class="d-flex align-items-center custom-dropdown">
                            <ActionDropdown :btnList="rerunBtnList" :icon="['fa', 'fa-caret-down', 'px-1']"
                                :iconStyle="{ color: '#ffffff', fontSize: '17px' }" />
                        </div>
                    </div>
                    <button v-if="showRevertPromotion && isAccessByUserRole(promotionAdminRoles)" class="btn btn-danger"
                        @click="onRevertClick">
                        <div>
                            <slot></slot>Revert
                        </div>
                    </button>
                    <button v-if="showCancelJobBtn" class="btn btn-secondary" @click="setCancelJob">
                        <div v-if="runClicked" class="spinner-border spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div v-else>
                            <slot></slot>Cancel Job
                        </div>
                    </button>
                    <button @click="closeClick" class="btn btn-secondary lift">
                        <i class="fa fa-arrow-left me-1"></i> Back to {{ isPipelineJob ? "Pipelines" : "Jobs" }} list
                    </button>
                    <ActionDropdown :btnList="btnList" />
                </div>
            </template>

        </nav-header>

        <div>
            <router-view :key="$route.fullPath" :editMode="editMode" :overrideEditMode="overrideEditMode"
                :snapOverride="snapOverride" :saveJobOverrideTrigger="saveJobOverrideTrigger"
                :runJobTrigger="runJobTrigger" :cancelJobTrigger="cancelJobTrigger" :reRunJobTrigger="reRunJobTrigger"
                :reRunJobTriggerWithImage="reRunJobTriggerWithImage" :pipelineJobs="underlyingPipelineJobs" v-on:setRunClick="setRunClick"
                v-on:hideRunJob="setHideRunJob" v-on:showCancelJob="setShowCancelJob"
                v-on:promotionList="setPromotionList" v-on:setShowRevertPromotion="setShowRevertPromotion"
                v-on:setOverrideEditMode="setOverrideEditMode" v-on:showOverrideEdit="setShowOverrideEdit"
                v-on:setSnapOverride="setSnapOverride" v-on:setActionDropDown="setActionDropDown"
                v-on:hideReRunJobBtn="setHideReRunJobBtn" v-on:reRunning="setReRunning" :job="job" :override="override"
                :meters="meters"></router-view>
        </div>

    </div>
</template>

<script>
import NavHeader from "../../components/NavHeader.vue";
import ActionDropdown from "../../components/ActionDropdown.vue";
import { mapActions } from "vuex";
import YAML from "yaml";
export default {
    name: "JobDetail",
    components: { NavHeader, ActionDropdown },
    data() {
        return {
            job: {},
            override: null,
            snapOverride: null,
            showActionDropDown: false,
            meters: null,
            error: "",
            selectedSandbox: this.$route.params.sandboxId,
            successMessage: "",
            editMode: false,
            overrideEditMode: false,
            jobs: this.$store.state.amdp.jobs,
            navigate: this.$router,
            runJobTrigger: false,
            cancelJobTrigger: false,
            runClicked: false,
            isButtonDisabled: false,
            cancelJob: false,
            hideRunJobBtn: false,
            showCancelJobBtn: false,
            showOverrideTab: false,
            showOverrideEdit: false,
            saveJobOverrideTrigger: false,
            promotionList: [],
            showRevertPromotion: false,
            promotionAdminRoles: [1, 1.5, 3],
            editDeleteOverrideRoles: [1, 1.5],
            showParametersTab: false,

            reRunning: false,
            hideReRunJobBtn: true,
            reRunJobTrigger: false,
            reRunJobTriggerWithImage: false,
            reRunJobRolesForProd: [1, 1.5], // only aqfer_admin and aqfer_manager can access rerun job for prod sandbox
            reRunJobRolesForProdV2: [1, 1.5, 3], // only aqfer_admin, aqfer_manager and client_admin can access rerun job for prod v2 sandbox

            // pipeline jobs info
			underlyingPipelineJobs: [],
        };
    },
    computed: {
        isProdV2Sandbox() { //hidePromotions
            let prodv2Sandboxes = this.$store.state.sandbox.prodV2Sandboxes;
            prodv2Sandboxes = prodv2Sandboxes.filter((sandbox => sandbox.name === this.selectedSandbox))
            return prodv2Sandboxes.length ? true : false;
        },
        isProdSandbox() {
            let prodSandboxes = this.$store.state.sandbox.prodSandboxes;
            prodSandboxes = prodSandboxes.filter((sandbox => sandbox.name === this.selectedSandbox))
            return prodSandboxes.length ? true : false;
        },
        btnList() {
            return [
                {
                    id: 1,
                    name: 'Add Override',
                    visible: !this.showOverrideTab && this.isAccessByUserRole(this.editDeleteOverrideRoles) && this.isProdV2Sandbox && this.showActionDropDown,
                    onClick: () => this.onAddOverride(),
                    icon: 'fa fa-plus',
                },
            ]
        },
        rerunBtnList() {
            return [
                {
                    id: 1,
                    name: 'Rerun with Image',
                    visible: !this.reRunning,
                    onClick: () => this.reRunJobClickWithImage(),
                    icon: 'fa-brands fa-docker',
                }
            ]
        },
        checkReRunJobRoles() {
            if (this.isProdV2Sandbox) return this.isAccessByUserRole(this.reRunJobRolesForProdV2);
            else if (this.isProdSandbox) return this.isAccessByUserRole(this.reRunJobRolesForProd);
            return false
        },
        isPipelineJob() {
            return this.job?.kind?.toLowerCase() === "pipeline";
        }
    },
    async beforeMount() {
        this.$store.dispatch("sandbox/setSandboxJobRuns", null); // Assigning null initially to override state
        this.$store.dispatch(
            "sandbox/setCurrentSandbox",
            this.$route.params.sandboxId
        );
        if (!this.jobs.length) {
            await this.$store.dispatch("amdp/fetchJobs", this.$route.params.sandboxId);
            await this.fetchJob();
        } else {

            await this.fetchJob();
        }
    },
    methods: {
        ...mapActions({
            readJob: "amdp/readJob",
            readOverrideFile: "sandbox/readOverrideFile",
            deleteOverrideFile: "sandbox/deleteOverrideFile",
            fetchParameters: "amdp/fetchLakeviewParameters",
            showModal: "showModal",
        }),
        async fetchJob() {
            let response;
            let self = this;
            try {
                response = await this.readJob({ sandboxName: this.$route.params.sandboxId, jobName: this.$route.params.jobId });
                this.job = await response.data;
                this.checkParameters();
                if (this.job.meters) {
                    this.meters = this.job.meters
                } else {
                    this.meters = [];
                }
                this.snapshot = JSON.parse(JSON.stringify(this.job)); // deep clone
                this.$store.dispatch("sandbox/fetchSandboxJobRuns", { jobName: this.job.name, limit: this.$store.state.sandbox.executionsListLimit });
            } catch (error) {
                if (error.response.data.error) this.error = error.response.data.error;
                else this.error = error.message;
            } finally {
                if (this.isProdV2Sandbox)
                    this.fetchOverrideFile()
                this.fetchUnderlyingPipelineJobs(); // if pipeline job, fetch the underlying pipeline jobs info for UI visualization
            }

        },
        async fetchUnderlyingPipelineJobs() {
            console.log("fetching underlying pipeline jobs");
			if (this.job?.kind?.toLowerCase() === "pipeline") {
				if (!this.job.system_files) return null;
				const configFile = this.job.system_files.find(
					f => f.relative_path === 'config.yaml'
				);
				const varsFile = this.job.system_files.find(
					f => f.relative_path === 'vars.yaml'
				);
				if (!configFile?.content) return null;

				let jobsInfo = [];
				try {
					// merging is required, since the config file may refer anchors defined in vars file.
					// yaml parser does not support a case where anchors are used but not defined.
					const mergedFile = (varsFile?.content || '') + '\n' + (configFile?.content || '');
					const parsed = YAML.parse(mergedFile);

					const jobNames = this.getJobNames(parsed);
					const readPromises = jobNames.map(async (jobName) => {
						return this.readJob({ sandboxName: this.$route.params.sandboxId, jobName: jobName }).then(response => {
							jobsInfo.push({jobDetails: response.data});
						});
					});
					const results = await Promise.allSettled(readPromises);
				} catch (e) {
					console.error('YAML parse error', e);
				} finally {
					this.underlyingPipelineJobs = [...jobsInfo];
				}
			}
		},
        getJobNames(input, names = []) {
			if (input.in_sequence) {
				input.in_sequence.forEach(item => this.getJobNames(item, names));
			} else if (input.in_parallel) {
				input.in_parallel.forEach(item => this.getJobNames(item, names));
			} else if (input.job_name) {
				names.push(input.job_name);
			}
			return names;
		},
        async fetchOverrideFile() {
            let response;
            try {
                response = await this.readOverrideFile(
                    this.$route.params.jobId
                );
                this.override = await response.data;
                if (this.override) {
                    this.showOverrideTab = true;
                    this.snapOverride = JSON.parse(JSON.stringify(this.override));
                }
                else
                    this.showOverrideTab = false;

            } catch (error) {
                this.showOverrideTab = false;
                if (error.response.data.error)
                    this.error = error.response.data.error;
                else this.error = error.message;
            }

        },
        checkParameters() {
            try {
                this.setParametersTab(false);
                this.job.system_files.map(file => {
                    if (file.relative_path == "vars.yaml") {
                        const documents = YAML.parseAllDocuments(file.content);
                        if (!documents.length) return;
                        const root = documents[0].toJS();
                        if (root && typeof root === 'object' && 'parameters' in root) {
                            this.fetchParameters({
                                sandboxName: `${this.$route.params.sandboxId}`,
                                jobName: `${this.$route.params.jobId}`
                            });
                            this.setParametersTab(true);
                        }
                    }
                })
            } catch (e) {
                console.error('YAML parsing error: ', e);
            }
        },
        runBtnClick() {
            this.runClicked = true;
            this.runJobTrigger = !this.runJobTrigger;
        },
        setRunJobBtnState(btnState) {
            this.isButtonDisabled = btnState;
        },
        setRunClick(runClick) {
            this.runClicked = runClick;
        },
        setHideRunJob(hideRunJob) {
            this.hideRunJobBtn = hideRunJob;
        },
        setCancelJob() {
            this.cancelJobTrigger = !this.cancelJobTrigger;
        },
        setShowCancelJob(showCancelJob) {
            this.showCancelJobBtn = showCancelJob;
        },
        closeClick() {
            this.$router.push({
                name: this.isPipelineJob ? "Pipelines" : "Jobs",
                params: {
                    sandboxId: `${this.$route.params.sandboxId}`,
                },
            });
        },
        closeNav(navName) {
            this.$router.push({
                name: "Job Run History",
                params: {
                    sandboxId: `${this.$route.params.sandboxId}`,
                    jobId: `${this.$route.params.jobId}`
                },
            });

        },
        setParametersTab(val) {
            // check if the current sandbox is a prod v2 sandbox
            this.showParametersTab = val && this.$store.state.sandbox.prodV2Sandboxes.map(sandbox => { return sandbox.name })
                .includes(this.$store.state.sandbox.currentSandbox);
        },
        onRevertClick() {
            this.showModal({ component: "RevertPromotion", data: { promotionList: this.promotionList } });
        },
        setPromotionList(list) {
            this.promotionList = list;
        },
        setShowRevertPromotion(showRevertPromotion) {
            this.showRevertPromotion = showRevertPromotion;
        },
        isAccessByUserRole(roles) {
            return this.$store.getters.userRoles.isAccessByRole(roles);
        },
        setActionDropDown(value) {
            this.showActionDropDown = value
        },
        setSaveOverride() {
            this.saveJobOverrideTrigger = !this.saveJobOverrideTrigger
        },
        setShowOverrideEdit(showOverride) {
            this.showOverrideEdit = showOverride;
        },
        setOverrideEditMode(mode) {
            this.overrideEditMode = mode;
            this.successMessage = null;
            this.error = null;
        },
        onAddOverride() {
            var self = this;
            this.showModal({
                component: "AddOverride", data: {
                    jobName: this.job.name,
                    sandboxEnv: "PROD_V2",
                    fetchOverrideFile: () => this.fetchOverrideFile()
                }
            });
        },
        setSnapOverride(override) {
            this.snapOverride = override;
            this.onOverrideCancelClick();
        },
        onOverrideEditClick() {
            this.setOverrideEditMode(true);
            this.setShowOverrideEdit(false);
        },
        onOverrideCancelClick() {
            this.override = { ...this.snapOverride };
            this.setOverrideEditMode(false);
            this.setShowOverrideEdit(true);
        },
        onOverrideDeleteClick() {
            const self = this;
            let toastoptions = "";
            this.showModal({
                component: "confirm",
                data: {
                    title: "Delete Override",
                    message: `Are you sure you want to delete override.yaml?`,
                    async confirm() {
                        try {
                            const response = await self.deleteOverrideFile(
                                self.job.name
                            );
                            self.$store.dispatch("hideModal");
                            self.setSnapOverride({});
                            self.showOverrideTab = false;
                            self.override = null;
                            toastoptions = {
                                message: "Override file deleted successfully.",
                                type: "success"
                            }
                            self.$router.push({
                                name: "Job Configuration",
                                params: {
                                    sandboxId: `${self.$route.params.sandboxId}`,
                                },
                            });
                        } catch (error) {
                            if (error.response.data.error)
                                this.error = error.response.data.error
                            else
                                this.error = error.message
                            toastoptions = {
                                message: this.error || "Error in deleting override file.",
                                type: "error"
                            }
                            self.onOverrideCancelClick();
                        }
                        self.$store.dispatch('addToast', toastoptions);
                    },
                },
            });
        },
        reRunJobClick() {
            this.reRunJobTrigger = !this.reRunJobTrigger;
        },
        reRunJobClickWithImage() {
            this.reRunJobTriggerWithImage = !this.reRunJobTriggerWithImage;
        },
        setHideReRunJobBtn(hideReRunJobBtn) {
            this.hideReRunJobBtn = hideReRunJobBtn;
        },
        setReRunning(reRunning) {
            this.reRunning = reRunning;
        },
    },
    watch: {
        '$route.params.jobId': {
            handler(newValue) {
                this.fetchJob();
            },
            deep: true
        }
    }
};
</script>

<style scoped>
.custom-btn-group {
    display: flex;
    align-items: center;
}

.btn {
    margin-right: 12px;
}

.custom-dropdown {
    background-color: #2a93b1;
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
}

.rerunning-btn {
    border-right: none !important;
    border-top-right-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
}

.rerun-btn {
    margin-right: 0px !important;
    border-right: 1px solid #ffffff !important;
}
</style>